import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = {
  id: "profile-menu-popover-dropdown",
  class: "profile-menu-container"
}
const _hoisted_2 = {
  key: 0,
  class: "profile-menu-container__popover-dropdown popover-dropdown"
}
const _hoisted_3 = { class: "popover-dropdown__content" }
const _hoisted_4 = { class: "popover-dropdown__header dropdown-header" }
const _hoisted_5 = { class: "dropdown-header__content" }
const _hoisted_6 = { class: "dropdown-header__icon" }
const _hoisted_7 = { class: "popover-dropdown__body dropdown-body" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "dropdown-body__content-item" }

import SvgLoader from '@/utils/SvgLoader.vue';
import { onMounted, onUnmounted, reactive } from 'vue';
import { DropDownMenuItem } from './interfaces/dropDownItem';
import { i18n } from '@/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileMenu',
  props: {
    userName: {},
    menuItems: {}
  },
  setup(__props: any) {

const t = i18n.t;

const props = __props;

const state = reactive({
  isOpen: false,
});

const toggleDropDown = () => {
  state.isOpen = !state.isOpen;
};

/**
 * ドロップダウンを閉じる
 * @param event - クリックイベント
 */
const closeDropdown = (event: MouseEvent) => {
  if (!(event.target as Element).closest(`#profile-menu-popover-dropdown`)) {
    state.isOpen = false;
  }
};

const onClickMenuItem = (item: DropDownMenuItem) => {
  item.action();
  state.isOpen = false;
};

onMounted(() => {
  document.addEventListener('click', closeDropdown);
});

onUnmounted(() => {
  document.removeEventListener('click', closeDropdown);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "profile-menu-container__icon",
      onClick: toggleDropDown
    }, [
      _createVNode(SvgLoader, { name: "person" })
    ]),
    (state.isOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(SvgLoader, { name: "personProfileHeader" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.userName), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.label,
                  class: "dropdown-body__content-item-container",
                  onClick: ($event: any) => (onClickMenuItem(item))
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    (item.icon)
                      ? (_openBlock(), _createBlock(SvgLoader, {
                          key: 0,
                          class: "dropdown-body__icon",
                          name: item.icon
                        }, null, 8, ["name"]))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_unref(t)(item.label)), 1)
                  ])
                ], 8, _hoisted_8))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})